import {CreatedMaintenanceRecordRequest} from '@di-shared/api/di/__generated';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export default function useSestName() {
  const {t} = useInferableTranslation();

  const sestNameLabels: Record<CreatedMaintenanceRecordRequest.sestCode, string> = {
    [CreatedMaintenanceRecordRequest.sestCode._01]: t('T30342'),
    [CreatedMaintenanceRecordRequest.sestCode._02]: t('T10116'),
    [CreatedMaintenanceRecordRequest.sestCode._03]: t('T10121'),
    [CreatedMaintenanceRecordRequest.sestCode._04]: t('T30344'),
    [CreatedMaintenanceRecordRequest.sestCode._09]: t('T30347'),
    [CreatedMaintenanceRecordRequest.sestCode._18]: t('T30077'),
    [CreatedMaintenanceRecordRequest.sestCode._21]: t('T30053'),
  };
  return {sestNameLabels};
}
